import BlueTopbarThumbnailPath from '../../../assets/template-thumbnails/topbar-center/blue-topbar-centered-template-thumbnail.png';

const BlueTopbarTemplate = {
    id: 'blue-topbar-template',
    name: 'Blue',
    category: 'Topbar Classic',
    settings: {
      layoutId: 'topbar-centered',
      designId: 'blue',
      style: 'tech',
      background: 'blank',
      barStyleId: 'bars',
      specialEffectId: 'timeline',
      typography: {
        cvTitle: { fontSize: 24, lineHeight: 1.4, fontFamily: "'Arial', sans-serif" },
        sectionTitle: { fontSize: 12, lineHeight: 1.2, fontFamily: "'Arial', sans-serif" },
        body: { fontSize: 10, lineHeight: 1, fontFamily: "'Arial', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Arial', sans-serif" },
      },
    },
    thumbnail: BlueTopbarThumbnailPath
  };

export default BlueTopbarTemplate; 